import React from "react";
import "./Common.css";
import "bootstrap-icons/font/bootstrap-icons.css";

const columns = [
  {
    key: "groups",
    title: "7 Beneficiary Groups",
    accentColor: "#FF4757",
    items: [
      "Children (6–59 months)",
      "Children (5–9 years)",
      "Adolescents (10–19 years)",
      "Pregnant Women",
      "Lactating Women",
      "Women of Reproductive Age (WRA) (20–49 years)",
      "Low Birth Weight Babies (0–6 months)",
    ],
  },
  {
    key: "interventions",
    title: "7 Interventions",
    accentColor: "#2ECC71",
    items: [
      "Prophylactic IFA Supplementation ",
      "Testing of anemia ",
      "Therapeutic management of anemia ",
      "Deworming and Delayed Cord Clamping ",
      "Jan Bhagidari – communication strategy ",
      "Addressing non-nutritional causes of anemia ",
      "Eating Right – promotion of locally available iron-rich food and diet diversification ",
    ],
  },
  {
    key: "mechanisms",
    title: "7 Institutional Mechanisms",
    accentColor: "#FF4757",
    items: [
      "Intra-ministerial coordination",
      "National Centre of Excellence and Advanced Research on Anemia ",
      "National AMB Abhiyaan Unit ",
      "Strengthening supply chain and logistics ",
      "Convergence with other Ministries ",
      "Anemia Mukt Bharat Abhiyaan Portal ",
      "Digital Framework for monitoring through T4 approach ",
    ],
  },
];

function Strategy777() {
  return (
    <section className="s777-section">
      <div className="container">
        {/* Header */}
        <div className="text-center s777-header">
          <div className="s777-badge">CORE FRAMEWORK</div>
          <h2 className="s777-title">7×7×7 Strategy</h2>
          <p className="s777-subtitle">
            A comprehensive approach targeting seven beneficiary groups through
            <br />
            seven interventions supported by seven institutional mechanisms
          </p>

          {/* 7 × 7 × 7 circles */}
          <div className="s777-circles">
            <div className="s777-circle s777-circle--red">7</div>
            <span className="s777-multiply">×</span>
            <div className="s777-circle s777-circle--green">7</div>
            <span className="s777-multiply">×</span>
            <div className="s777-circle s777-circle--red">7</div>
          </div>
        </div>

        {/* 3-column cards */}
        <div className="s777-cards">
          {columns.map((col) => (
            <div className="s777-card" key={col.key}>
              {/* Card title */}
              <h3
                className="s777-card-title"
                style={{ "--accent": col.accentColor }}
              >
                {col.title}
              </h3>

              {/* Items */}
              <ul className="s777-list">
                {col.items.map((item, i) => (
                  <li className="s777-item" key={i}>
                    <span
                      className="s777-check"
                      style={{ background: col.accentColor }}
                    >
                      <i className="bi bi-check"></i>
                    </span>
                    <span className="s777-item-text">{item}</span>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default Strategy777;
